import ptBRIntl from "antd/lib/locale/pt_BR";
import { ProCard, ProTable } from "@ant-design/pro-components";
import { Button, ConfigProvider, Input, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { defaultTablePagination } from "utils/table-pagination";

export const MyReports = ({ data, columns, setIsModalVisible, navigate, location, tabKey, getReports }) => {
    const NAME_FILTERS_LOCAL_STORAGE = {
        SEARCH: `search-${tabKey}-selectedReport`,
    };

    const NAME_QUERY_PARAMS = {
        SEARCH: `search-${tabKey}`,
    };

    const urlParams = new URLSearchParams(location.search);
    const initialSearch = urlParams.get(NAME_QUERY_PARAMS.SEARCH) || localStorage.getItem(NAME_FILTERS_LOCAL_STORAGE.SEARCH) || "";
    const [search, setSearch] = useState(initialSearch);

    // UseEffect para atualizar a URL com query params/localStorage
    useEffect(() => {
        const newUrlParams = new URLSearchParams(location.search);

        if (search) {
            newUrlParams.set(NAME_QUERY_PARAMS.SEARCH, search);
            localStorage.setItem(NAME_FILTERS_LOCAL_STORAGE.SEARCH, search);
        } else {
            newUrlParams.delete(NAME_QUERY_PARAMS.SEARCH);
            localStorage.removeItem(NAME_FILTERS_LOCAL_STORAGE.SEARCH);
        }

        if (newUrlParams.toString() !== location.search.substring(1)) {
            navigate({
                pathname: location.pathname,
                search: newUrlParams.toString(),
            });
        }

    }, [search, navigate, location.pathname, location.search, NAME_QUERY_PARAMS.SEARCH, NAME_FILTERS_LOCAL_STORAGE.SEARCH]);

    const handleAddClick = () => {
        setIsModalVisible(true);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const items = search.length > 0 ? data.filter(({ name }) => name.toLowerCase().startsWith(search.toLowerCase())) : data;

    return (
        <ProCard>
            <ConfigProvider locale={ptBRIntl}>
                <div style={{ marginBottom: 16 }}>
                    <Input.Search
                        placeholder="Buscar por nome"
                        value={search}
                        onChange={handleSearchChange}
                        allowClear
                        style={{ width: "100%" }}
                    />
                </div>
                <ProTable
                    search={false}
                    rowKey="_id"
                    type="table"
                    pagination={defaultTablePagination}
                    columnsState={{
                        persistenceKey: "clm-pro-table-search-results-my-reports",
                        persistenceType: "sessionStorage",
                    }}
                    columns={columns}
                    dataSource={items}
                    dateFormatter={"number"}
                    scroll={{ x: true }}
                    style={{ padding: 0, height: "100%", width: "100%" }}
                    options={{
                        reload: () => {
                            if (getReports) getReports();
                        }
                    }}
                    toolbar={{
                        actions: [
                            <Button type="primary"
                                onClick={handleAddClick}>
                                Adicionar
                            </Button>
                        ],
                    }}
                />
            </ConfigProvider>
        </ProCard>)
}
